// extracted by mini-css-extract-plugin
export default {"button":"nk-z","reviewSort":"ok-z"};